import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { startNewChat } from "../store/actions/startNewChatAction";

export const useStartNewChat = () => {
    const dispatch = useDispatch();

    return useCallback(() => {
        dispatch(startNewChat());
    }, [dispatch]);
};
